import React, { useEffect, useRef } from 'react';
import styles from './AppointmentCard.scss';
import { getStatusLabel, getTypeLabel, formatAppointmentDate } from '../Appointments';
import { trackGA, gaEvent } from 'services/ga';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next'

const AppointmentCard = ({ appointment, activeTabIndex, profileId, onShowInfo }) => {
  const { t } = useTranslation();
  const hasTrackedShowEvent = useRef(false);

  useEffect(() => {
    if (!hasTrackedShowEvent.current) {
      const statusName =
        activeTabIndex === 1
          ? appointment.status === 0
            ? 'v_rabote'
            : 'naznachen'
          : appointment.status === 2
          ? 'proveden'
          : 'otmenen';

      const eventContent = `${statusName} | ${appointment.type}`;

      trackGA(
        gaEvent.profileAppointmentCardShow({
          eventContent,
          productName: appointment.buildingName,
          productID: appointment.buildingId,
          user_id: profileId,
        })
      );

      hasTrackedShowEvent.current = true;
    }
  }, [activeTabIndex, appointment, profileId]);

  const handleShowInfo = () => {
    const eventContent =
      appointment.status === 0 || appointment.status === 1
        ? 'budushchie_zapisi'
        : 'proshedshie_zapisi';

    trackGA(
      gaEvent.profileAppointmentButtonClick({
        eventContent,
        // productType,
        productName: appointment.buildingName,
        productID: appointment.buildingId,
        user_id: profileId,
      })
    );

    onShowInfo(appointment);
  };

  return (
    <div className={styles.AppointmentCard}>
      <div className={styles.CardStatus}>
        {getStatusLabel(appointment.status, t)}
        {getTypeLabel(appointment.type, t)}
      </div>
      <div className={styles.CardContent}>
        <div className={styles.AppointmentInfo}>
          <div className={styles.BuildingName}>{appointment.buildingName}</div>
          <div className={styles.Data}>
            {formatAppointmentDate(appointment.dateTimeFrom, t, i18next.language)}
          </div>
        </div>
        <button
          className={cn(styles.ShowAppointmentButton, 'button-default', 'button-primary--lg')}
          onClick={handleShowInfo}
        >
          Смотреть
        </button>
      </div>
    </div>
  );
};

export default AppointmentCard;



// WEBPACK FOOTER //
// ./src/components/Profile/Appointments/AppointmentCard/AppointmentCard.jsx